import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M20.779 4.28a.75.75 0 0 0-1.061-1.06l-5.594 5.594v-3.69a.75.75 0 0 0-1.5 0v5.5a.75.75 0 0 0 .75.75h5.4990000000000006a.75.75 0 0 0 0-1.5h-3.688zM5.125 12.624a.75.75 0 0 0 0 1.5h3.689L3.22 19.718a.75.75 0 1 0 1.06 1.06l5.594-5.593v3.688a.75.75 0 0 0 1.5 0v-5.499a.75.75 0 0 0-.458-.691.8.8 0 0 0-.292-.059z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }